import { respawnSession, setSessionId } from './../actions/session';
import { reConnect, setSocket, setSocketError, setSocketPending, setSocketSuccess, setSocketTimeout } from "./../actions/socket";
import { clearAuth } from './../actions/auth';
import { fork, call, take, put, takeLatest, select, delay, race} from "redux-saga/effects";
import io from "socket.io-client";
import { handleUserAction } from "./user";
import { handleMessageAction } from "./message";
import Cookies from "js-cookie";
import { eventChannel } from "redux-saga";
import { Socket as SocketValue } from 'socket.io-client';
import { handleBotAction } from './bot';

type Socket = typeof SocketValue;



// New helper: wait for setSessionId action or timeout
function* getSessionIdWithRetry(maxWaitMs = 100) {  // generous timeout
	// console.log("getSessionIdWithRetry...")

  const { sessionAction, timedOut } = yield race({
    sessionAction: take(setSessionId),          // waits for this exact action
    timedOut: delay(maxWaitMs),
  });

  if (timedOut) {
    // console.warn(`[waitForSetSessionId] Timed out after ${maxWaitMs}ms - proceeding without sessionId`);
    return null;
  }

  // sessionAction.payload.id is guaranteed to be the new value
  const id = sessionAction.payload.id;
  // console.log('[waitForSetSessionId] Got sessionId from action:', id);
  return id;
}



function subscribe (socket: Socket) {
	return eventChannel((emit) => {

		// remove old cookie 
		socket.on("timeout", () => {
			// Cookies.remove("sessionId");
			// window.location.reload();
			emit(setSocketTimeout({timeout:true}));
			emit(clearAuth());    // emit() in eventChannel → put() in read saga → dispatch to store
		});

		// respawn session
		socket.on('respawnSession', ({type}: {type: 'agent' | 'user' | 'guest'}) => {
		 	emit(respawnSession({
				// id: Cookies.get("sessionId") || "",
				id: "",
				userType: type,
			}));
		});

		// set session if server distribute client a new session id
		socket.on('setSessionId', ({sessionId}: {sessionId: string}) => {
			// Cookies.set("sessionId", sessionId);   // using redux reducer auth.id instead
			// console.log("🚀 ~ subscribe ~ sessionId:", sessionId)
			
			emit(setSessionId({
				id: sessionId,
			}));
		});

		// on connected
		socket.on("connect", () => {
			emit(setSocketSuccess());
		});

		socket.on('disconnect', () => {
			window.location.reload();
			emit(setSocketTimeout({timeout:true}));
		});

		return () => {}
	});
}


function* read (socket: Socket) {
	const channel = yield call(subscribe, socket);

	while (true) {
		const action = yield take(channel);
		yield put(action);
	}
}


function* write (endpoint: string) {

	yield takeLatest(reConnect, function* (action) {

		// const sessionId = Cookies.get('sessionId');
		const sessionId = yield call(getSessionIdWithRetry);

		// debug print
		// console.log("🚀 ~ debug print(2): write ~ sessionId:", sessionId)
		
		yield put(setSocketPending());

		try {
		const socket = io(endpoint, {
			...(sessionId && {
				query: {
					sessionId,
				}
			}),
		});
		// console.log(socket)
		yield put(setSocketSuccess())
		return socket

		}
		catch(e) {
			yield put(setSocketError())
		}
		
	});
}


// function connect(endpoint: string) {
// 	// get session id by cookie
// 	// const sessionId = Cookies.get('sessionId');
// 	const sessionId = yield call(getSessionIdWithRetry);

// 	// debug print
//   console.log("🚀 ~ debug print(3): connect ~ sessionId:", sessionId)

// 	// attach session id retrieved from cookie if not undefined
// 	const socket = io(endpoint, {
// 		...(sessionId && {
// 			query: {
// 				sessionId,
// 			}
// 		}),
// 	});

// 	return socket;
// }




// Change connect to accept sessionId as a parameter
function connect(endpoint: string, sessionId: string | null) {
    // debug print
    // console.log("🚀 ~ connect ~ sessionId:", sessionId)

    // attach session id if available
    const socket = io(endpoint, {
        ...(sessionId && {
            query: {
                sessionId,
            }
        }),
    });

    return socket;
}



function* flow() {
	// set socket status
	yield put(setSocketPending());

	// connect to socket io server
	const { payload } = yield take(setSocket);
	// console.log("🚀 ~ flow ~ setSocket:", setSocket)
	// console.log("🚀 ~ flow ~ payload:", payload)

	// Get sessionId from Redux in the saga
  const sessionId = yield call(getSessionIdWithRetry);
  // console.log("🚀 ~ flow ~ sessionId:", sessionId)

	// const socket = yield call(connect, payload.endpoint);
	const socket = yield call(connect, payload.endpoint, sessionId);      // Pass sessionId to the regular function
	// console.log("🚀 ~ flow ~ socket:", socket)

	
	const reSocket = yield fork(write, payload.endpoint);
	// session id
	yield fork(read, socket);


	// invoke all middleware to take all of the action
	yield fork(handleMessageAction, socket);
	yield fork(handleUserAction, socket);
	yield fork(handleBotAction, socket);
}


export default function* rootSaga() {
	yield fork(flow);
}







